import { replace } from 'out-of-character';

import { embedRegistry } from './registry';
import type { EmbedDefinition, EmbedProviderConfig } from './types';

/**
 * Factory function to create embed providers with minimal boilerplate.
 * Handles URL cleaning, matching, and registry registration automatically.
 */
export function createEmbedProvider(config: EmbedProviderConfig): EmbedDefinition {
  const { regex, buildEmbedUrl, id, label, icon } = config;

  const matcher = (url: string): boolean => regex.test(replace(url));

  const convertUrl = (url: string): string => {
    const cleaned = replace(url);
    const match = cleaned.match(regex);

    return match ? buildEmbedUrl(match, cleaned) : url;
  };

  const provider: EmbedDefinition = {
    id,
    label,
    icon,
    placeholder: config.placeholder ?? `Paste a ${label} link...`,
    invalidUrlMessage: config.invalidUrlMessage ?? `Please enter a valid ${label} URL`,
    matcher,
    convertUrl,
    renderProps: {
      title: config.buildTitle ?? (() => `${label} Embed`),
      ...config.renderProps,
    },
  };

  embedRegistry.register(provider);

  return provider;
}
